import { useContext, useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

import ViewIcon from "assets/icons/palette.svg?react";
import settingService from "api/settingsService";
import settingsContext, { IOptionType } from "contexts/SettingsContext";
import {
  FormControl,
  MenuItem,
  Select,
} from "@mui/material";
import FooterConfig from "./FooterConfig";
import InputAppearanceTab from "./InputAppearanceTab";
import { useTranslation } from "react-i18next";

const ViewTab: FC<Props> = () => {
  const { t } = useTranslation();
  // Sekcje zwijane zaprezentowane jako dwie osobne podzakładki.
  const [subTab, setSubTab] = useState<"app" | "footer" | "inputs">("footer");

  const { mutate: updateSetting } = settingService.useUpdateSetting();

  const [attachmentsLocation, setAttachmentsLocation] =
    useState<string>("center");
  const [participnatsLocation, setParticipantsLocation] =
    useState<string>("center");

  const [caseNewTabView, setCaseNewTabView] = useState<string>("center");

  const { options, setOptions } = useContext(settingsContext);

  useEffect(() => {
    if (options) {
      const attL = options.find(
        (x) => x.Type === IOptionType.caseAttachAttachmentsLocation
      );

      if (attL) {
        setAttachmentsLocation(attL.Value);
      }

      const partL = options.find(
        (x) => x.Type === IOptionType.caseAttachParticipantsLocation
      );

      if (partL) {
        setParticipantsLocation(partL.Value);
      }

      const caseNewTabV = options.find(
        (x) => x.Type === IOptionType.caseInNewTabView
      );

      if (caseNewTabV) {
        setCaseNewTabView(caseNewTabV.Value);
      }
    }
  }, [options]);

  const handleUpdate = (type: IOptionType, value: boolean | string) => {
    const newOptions = [...options];

    const op = newOptions.find((o) => o.Type === type);
    if (op) {
      op.Value = value.toString();
    }

    setOptions(newOptions);

    updateSetting({
      Type: type,
      Value: value.toString(),
    });
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.group}>
        <div className={styles.title}>
          <ViewIcon></ViewIcon>{t("settings.view.title")}
        </div>
        <div className={styles.subTabs}>
          <div
            className={`${styles.subTab} ${
              subTab === "footer" ? styles.subTabActive : ""
            }`}
            onClick={() => setSubTab("footer")}
          >
            {t("settings.email.footerConfig")}
          </div>
          <div
            className={`${styles.subTab} ${
              subTab === "app" ? styles.subTabActive : ""
            }`}
            onClick={() => setSubTab("app")}
          >
            {t("settings.view.appConfigHeader")}
          </div>
          <div
            className={`${styles.subTab} ${
              subTab === "inputs" ? styles.subTabActive : ""
            }`}
            onClick={() => setSubTab("inputs")}
          >
            Wygląd pól
          </div>
        </div>

        {subTab === "app" && (
          <>
            <div className={styles.hint}>
              {t("settings.view.appConfigHint")}
            </div>
            <div className={styles.settings}>
              <div className={styles.setting}>
                <div>
                  {t("settings.view.attachmentsLocationLabel")}
                </div>
                <div className={styles.col1}>
                  <FormControl
                    hiddenLabel={true}
                    size="small"
                    variant="filled"
                    sx={{ minWidth: 140 }}
                  >
                    <Select
                      id="select01"
                      value={attachmentsLocation}
                      onChange={(event) => {
                        handleUpdate(
                          IOptionType.caseAttachAttachmentsLocation,
                          event.target.value
                        );
                      }}
                    >
                      <MenuItem value={"left"}>{t("settings.view.toLeft")}</MenuItem>
                      <MenuItem value={"center"}>{t("settings.view.center")}</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>
              <div className={styles.setting}>
                <div>
                  {t("settings.view.participantsLocationLabel")}
                </div>
                <div className={styles.col1}>
                  <FormControl
                    hiddenLabel={true}
                    size="small"
                    variant="filled"
                    sx={{ minWidth: 140 }}
                  >
                    <Select
                      id="select02"
                      value={participnatsLocation}
                      onChange={(event) => {
                        handleUpdate(
                          IOptionType.caseAttachParticipantsLocation,
                          event.target.value
                        );
                      }}
                    >
                      <MenuItem value={"left"}>{t("settings.view.toLeft")}</MenuItem>
                      <MenuItem value={"center"}>{t("settings.view.center")}</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>
              <div className={styles.setting}>
                <div>
                  {t("settings.view.caseNewTabLabel")}
                </div>
                <div className={styles.col1}>
                  <FormControl
                    hiddenLabel={true}
                    size="small"
                    variant="filled"
                    sx={{ minWidth: 140 }}
                  >
                    <Select
                      id="select03"
                      value={caseNewTabView}
                      onChange={(event) => {
                        handleUpdate(
                          IOptionType.caseInNewTabView,
                          event.target.value
                        );
                      }}
                    >
                      <MenuItem value={"fullscreen"}>{t("settings.view.fullscreen")}</MenuItem>
                      <MenuItem value={"center"}>{t("settings.view.center")}</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>
            </div>
          </>
        )}

        {subTab === "footer" && <FooterConfig />}

        {subTab === "inputs" && <InputAppearanceTab />}
      </div>
    </div>
  );
};

export default ViewTab;
